export default __webpack_public_path__ + "static/media/promo-trends.66d60da7.png";